module.exports = __webpack_public_path__ + "img/c6.d5da2889.png";